<template>
  <div class="container">
    <div v-if="listNotif.length == 0">
      <v-row>
        <v-col cols="12">
          <div class="d-flex flex-column justify-center align-center">
            <div>
              <v-img
                max-height="240"
                max-width="240"
                src="@/assets/noNotif.png"
                >
              </v-img>
            </div>
            <div>
              <p class="text-h6 font-weight-bold">Tidak ada Notifikasi</p>
            </div>
            <div>
              <p>When you get notifications, they’ll show up here</p>
            </div>
            <div class="btn-reload" @click="loadNotif">
              <p class="text-h6 mt-2">Memuat Ulang</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div v-if="listNotif.length">
      <v-row no-gutters>
        <v-col cols="12">
          <div class="riwayatPoin">
            <p class="text-h6 font-weight-bold">Notifikasi Kamu</p>
          </div>
        </v-col>
      </v-row>
      <v-row>
          <v-col cols="12">
            <div class="pl-3 mb-3 mt-10 list-notif-container" v-for="(notif, index) in listNotif" :key="notif.internalId"
            :class="{ unread: notif.notificationFlag == 'Belum Dibaca'}"
            @click="showDetailNotif(notif, index)">
              <div class="d-flex justify-space-between pa-3">
                <div class="d-flex flex-row">
                  <v-icon large v-if="notif.notificationFlag == 'Belum Dibaca'">mdi-email-outline</v-icon>
                  <v-icon large v-else>mdi-email-open-outline</v-icon>
                  <div>
                    <p class="ml-3 font-weight-bold ma-0 text-truncate">{{ notif.notification }}</p>
                    <p class="ml-3 font-weight-thin ma-0">{{ notif.notificationDate }}</p>
                  </div>
                </div>
                <div>
                  <p class="font-weight-medium">{{ notif.notificationFlag }}</p>
                </div>
              </div>
              <!-- <v-divider class="mb-3"></v-divider> -->
            </div>
            <div class="text-center">
              <v-btn class="btn-load-more" v-if="btnLoadMore" @click="loadMoreHistory">
                Load More
              </v-btn>
            </div>
          </v-col>
      </v-row>
      <v-row>
        <v-dialog
          v-model="dialogDtlNotif"
          persistent
          max-width="450"
          max-height="350"
          width="100%"
        >
          <v-card class="pa-3">
            <div class="d-flex align-center justify-center mb-2">
              <v-img
                max-height="40"
                max-width="40"
                src="@/assets/acute.png"
              ></v-img>
            </div>
            <v-card-text class="text-center font-weight-bold">
              {{ showMessage }}
            </v-card-text>
            <v-card-text class="text-center">
              <v-spacer></v-spacer>
              <v-btn
                outlined
                class="text-capitalize ml-2"
                small
                text
                color="black"
                @click="dialogDtlNotif = false"
              >
                Tutup
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data(){
    return {
      listNotif: [],
      btnLoadMore: false,
      pageNumber: 2,
      dialogDtlNotif: false,
      showMessage: ''
    }
  },
  methods: {
    ...mapActions(['getNotifications','updateNotification']),

    showDetailNotif(notif, index){

      if (this.listNotif[index].notificationFlag == 'Dibaca') {
        this.showMessage = this.listNotif[index].notification;
        this.dialogDtlNotif = true;
      }else{
        this.updateNotification({
          internalId: notif.internalId
        })
        .then(() => {
          this.listNotif[index].notificationFlag = 'Dibaca';
          this.showMessage = this.listNotif[index].notification;
          this.dialogDtlNotif = true;
        })
      }
    },
    
    loadNotif(){
      this.getNotifications({
        pageNumber: 1,
        pageSize: 10
      })
      .then((response) => {
        console.log(response)
        this.listNotif = response.data.data.listData;

        this.btnLoadMore = this.listNotif.length < response.data.data.totalData;
      })
    },

    async loadMoreHistory(){
      await this.getNotifications({
        pageNumber: this.pageNumber,
        pageSize: 10
      })
      .then((response) => {
        // console.log(response);
        this.listNotif.push.apply(this.listNotif, response.data.data.listData);

        if(this.listNotif.length < response.data.data.totalData){
          this.btnLoadMore = true;
          this.pageNumber = this.pageNumber + 1;
        }else{
          this.btnLoadMore = false;
        }
      })
    },

    toDetailTransaction(){
      console.log('mask')
    }
  },
  mounted(){
    this.loadNotif();

  }
}
</script>

<style scoped src="./Notifications.scss" lang="scss" />
